export default __webpack_public_path__ + "static/white-2962d2c8d9d82260e3ece1ca97debb3d.jpg";